<div class="payment-result-container" [ngClass]="{'success': isSuccess, 'failure': !isSuccess}">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-md-8 col-lg-6">
                <mat-card class="payment-result-card">
                    <mat-card-content>
                        <!-- Loading State -->
                        <div class="loading-content text-center" *ngIf="isLoading">
                            <mat-progress-spinner mode="indeterminate" diameter="50"></mat-progress-spinner>
                            <p class="loading-text mt-3">Loading payment details...</p>
                        </div>

                        <!-- Result Content -->
                        <div class="result-content text-center" *ngIf="!isLoading">
                            <!-- Icon -->
                            <div class="result-icon-wrapper">
                                <mat-icon [ngClass]="{'success-icon': isSuccess, 'failure-icon': !isSuccess}">
                                    {{isSuccess ? 'check_circle' : 'error'}}
                                </mat-icon>
                            </div>

                            <!-- Title -->
                            <h1 class="result-title">{{getTitle()}}</h1>

                            <!-- Message -->
                            <p class="result-message">
                                {{getMessage()}}
                            </p>

                            <!-- Payment Details (Optional - can be populated dynamically) -->
                            <div class="payment-details" *ngIf="paymentDetails && (paymentDetails.amount || paymentDetails.date)">
                                <div class="detail-row" *ngIf="paymentDetails.amount">
                                    <span class="detail-label">Amount:</span>
                                    <span class="detail-value">{{paymentDetails.amount}}</span>
                                </div>
                                <div class="detail-row" *ngIf="paymentDetails.date">
                                    <span class="detail-label">Date:</span>
                                    <span class="detail-value">{{paymentDetails.date}}</span>
                                </div>
                            </div>

                            <!-- Additional Information -->
                            <div class="additional-info mt-4" *ngIf="isSuccess">
                                <p class="info-text">
                                    A confirmation email has been sent to your registered email address with all the details.
                                </p>
                            </div>

                            <!-- Error Information -->
                            <div class="error-info mt-4" *ngIf="!isSuccess && paymentDetails?.errorMessage">
                                <p class="error-text">
                                    {{paymentDetails.errorMessage}}
                                </p>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
</div>
